import React, { PropsWithChildren } from 'react';
import { Loader } from 'elmo-elements';
import { SelectWrapper } from './styles';

type TProps = PropsWithChildren<{ isLoading?: boolean }>;

export const SelectLoadingOverlay = (props: TProps) => {
    const { children, isLoading = false } = props;
    return (
        <SelectWrapper>
            {children}
            {isLoading ? <Loader type="spinner" /> : null}
        </SelectWrapper>
    );
};
